import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'
import helper from './helper'
import Multiselect from 'vue-multiselect'
import '@/assets/css/multiselect-bs4.css'

/// ===== LOCAL DEV
// const BASE_API_PATH = "http://localhost:3434/"
// const BASE_FILE_PATH = "http://localhost/megamulia"

/// ===== PRODUCTION
const BASE_API_PATH = "https://api.mm.mahagridjakuta.com/"
const BASE_FILE_PATH = "https://file.mm.mahagridjakuta.com"

axios.defaults.baseURL = BASE_API_PATH
axios.defaults.timeout = 120000
axios.defaults.headers.post['Accept'] = 'application/json'
axios.defaults.headers.common['Authorization'] = localStorage.getItem("token") || ""

// Interceptors for 401 responses (unauthorized)
axios.interceptors.response.use(function(response) {
    return response
}, function (error) {

    console.log(error.response)

    if(error.response && error.response.status == 401) {

        axios.defaults.headers.common['Authorization'] = ""
        var version = localStorage.getItem("version")
        localStorage.clear()
        localStorage.setItem("version", version)

        router.push("/login")

    }

    return Promise.reject(error)

})

Vue.use(BootstrapVue)
Vue.component('multiselect', Multiselect)
Vue.prototype.$axios = axios
Vue.prototype.$helper = helper
Vue.prototype.$BASE_FILE_PATH = BASE_FILE_PATH

/// GLOBAL COMPONENTS
/// Base components
const requireComponent = require.context('./globals', false, /[A-Z]\w+\.(vue|js)$/)

requireComponent.keys().forEach(fileName => {

    const componentConfig = requireComponent(fileName)
    let compName = fileName.includes("Loading") ? "LoadingWidget" : "PageSizer"

    Vue.component(compName, componentConfig.default || componentConfig)

})

new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App
    }
})
